import * as React from 'react';

import CheckBox from '@/components/elements/Form/CheckBox';
import { isPossibleMulti } from '@/lib/race';
import { BetMethod, BetTypeList, IsMultiData } from '@/modelTypes';

interface CheckMultiProps {
  betMethod: BetMethod;
  betTypeList: BetTypeList;
  isMultiData: IsMultiData;
  setIsMultiData: React.Dispatch<React.SetStateAction<IsMultiData>>;
}

const CheckMulti: React.FC<CheckMultiProps> = React.memo(
  ({ betMethod, betTypeList, isMultiData, setIsMultiData }) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      e.persist();
      setIsMultiData(prev => {
        const newData = { ...prev };
        if (betMethod === BetMethod.Formation) {
          newData[betMethod] = e.target.checked;
        }
        if (betMethod === BetMethod.Wheel) {
          newData[betMethod][betTypeList[betMethod]] = e.target.checked;
        }
        return newData;
      });
    };

    return (
      <>
        {betMethod === BetMethod.Formation && (
          <CheckBox
            htmlFor="multiCheckBox"
            checked={isMultiData[betMethod]}
            onChange={e => handleChange(e)}
          >
            マルチ
          </CheckBox>
        )}
        {betMethod === BetMethod.Wheel &&
          isPossibleMulti(betTypeList[betMethod]) && (
            <CheckBox
              htmlFor="multiCheckBox"
              checked={isMultiData[betMethod][betTypeList[betMethod]]}
              onChange={e => handleChange(e)}
            >
              マルチ
            </CheckBox>
          )}
      </>
    );
  },
);

export default CheckMulti;
